import React from "react";
import {
    Box,
    Paper,
    Typography,
} from "@mui/material";

import LocalShippingIcon from "@mui/icons-material/LocalShipping";
import ChevronRightIcon from "@mui/icons-material/ChevronRight";

const TruckCard = ({ plate, name, onClick }) => {
    return (
        <Paper
            elevation={0}
            onClick={onClick}
            sx={{
                width: "100%",
                height: "100%",
                minHeight: 170,
                borderRadius: "14px",
                border: "1px solid #e2e8f0",
                backgroundColor: "#ffffff",
                cursor: "pointer",
                overflow: "hidden",
                transition:
                    "all 0.2s ease",
                "&:hover": {
                    borderColor: "#90caf9",
                    boxShadow:
                        "0 8px 24px rgba(15, 23, 42, 0.08)",
                },
            }}
        >
            <Box
                sx={{
                    padding: 2.5,
                    height: "100%",
                    display: "flex",
                    flexDirection: "column",
                    justifyContent: "space-between",
                }}
            >
                {/* ICONO */}
                <Box
                    sx={{
                        display: "flex",
                        justifyContent:
                            "space-between",
                        alignItems: "center",
                    }}
                >
                    <Box
                        sx={{
                            width: 48,
                            height: 48,
                            borderRadius: "11px",
                            display: "flex",
                            alignItems:
                                "center",
                            justifyContent:
                                "center",
                            backgroundColor:
                                "#eaf2ff",
                            color: "#1976d2",
                        }}
                    >
                        <LocalShippingIcon
                            sx={{
                                fontSize: 27,
                            }}
                        />
                    </Box>

                    <Box
                        sx={{
                            width: 32,
                            height: 32,
                            borderRadius: "8px",
                            display: "flex",
                            alignItems:
                                "center",
                            justifyContent:
                                "center",
                            color: "#94a3b8",
                            backgroundColor:
                                "#f8fafc",
                        }}
                    >
                        <ChevronRightIcon />
                    </Box>
                </Box>

                {/* INFORMACIÓN */}
                <Box
                    sx={{
                        marginTop: 3,
                    }}
                >
                    <Typography
                        variant="caption"
                        sx={{
                            color: "#64748b",
                            display: "block",
                            marginBottom: "4px",
                        }}
                    >
                        Placa
                    </Typography>

                    <Typography
                        variant="h6"
                        sx={{
                            fontWeight: 700,
                            color: "#1f2937",
                            lineHeight: 1.2,
                        }}
                    >
                        {plate}
                    </Typography>

                    <Typography
                        variant="body2"
                        sx={{
                            color: "#64748b",
                            marginTop: "6px",
                            whiteSpace:
                                "nowrap",
                            overflow:
                                "hidden",
                            textOverflow:
                                "ellipsis",
                        }}
                    >
                        {name}
                    </Typography>
                </Box>
            </Box>
        </Paper>
    );
};

export default TruckCard;